export const name = document.createElement("h3");
name.innerText = "Алена Федоренко";
